import React from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import GridContainer from "components/Grid/GridContainer.js";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import FormControl from "@mui/material/FormControl";
import GridItem from "components/Grid/GridItemLogin.js";
import CloseIcon from "@mui/icons-material/Close";
import { Tooltip } from "@material-ui/core";
import Chuahoanthanhct from "components/Dashboard/Chuahoanthanhct.js";
import Config from "conFig.js";
import { withStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/components/chucnangStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
const BlueOnGreenTooltip = withStyles({
  tooltip: { backgroundColor: "#c2c800" },
})(Tooltip);

const Chuahoanthanh = React.memo(function Chuahoanthanh(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [data, setData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [idmau, setIdmau] = React.useState(0);
  const handleClose = () => setOpen(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdata = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashdonvichuabaocao?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gotoopen = (id) => {
    setIdmau(id);
    setOpen(true);
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tabledb_th}>STT</th>
          <th className={classes.tabledb_th}>Nội dung</th>
          <th className={classes.tabledb_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {data.map((row, i) => {
          return (
            <tr key={i}>
              <td className={classes.tabledb_td}>{row["stt"]}</td>
              <td className={classes.tabledb_td}>{row["maubaocao"]}</td>
              <BlueOnGreenTooltip
                title={<a className={classes.tooltip}> Xem chi tiết </a>}
                key={i}
                placement="top-start"
              >
                <td
                  onClick={() => gotoopen(row["stt"])}
                  style={{ cursor: "default" }}
                  className={classes.chuaht_td_number}
                >
                  {Number(row["ts_chuabc"]).toLocaleString()}
                </td>
              </BlueOnGreenTooltip>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = data.length > 0 ? renderTableBody() : null;
  React.useEffect(() => {
    getdata();
  }, [thangnam]);
  return (
    <div className={classes.table} style={{ height: "170px" }}>
      <table className={classes.tabledb}>
        {tHead}
        {tBody}
      </table>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary">
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormControl
                        style={{ width: "100%", marginTop: "-35px" }}
                      >
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Chi tiết
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={8}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl
                        style={{ width: "100%", marginTop: "-45px" }}
                      >
                        <CloseIcon onClick={handleClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody className={classes.card_body_slst}>
                  <Chuahoanthanhct idmau={idmau} thangnam={thangnam} />
                </CardBody>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </div>
  );
});

Chuahoanthanh.propTypes = {
  thangnam: PropTypes.object,
};
export default Chuahoanthanh;
